import { Check } from '@sgcmpteltd/uikit-react';
import cx from 'clsx';
import Image from 'next/image';

import { TextLink } from '@/components/text-link';
import { joinSgcmMedia, joinSgcmSite } from '@/utils/url/join/public';

import {
  COLUMN_TITLE_DEALER,
  COLUMN_TITLE_PRICE,
  COLUMN_TITLE_SUBMODEL,
  ICON_SIZE_IN_PIXEL,
  TEXT_READY_STOCK_DESC_FIVE,
  TEXT_READY_STOCK_DESC_FOUR,
  TEXT_READY_STOCK_DESC_ONE,
  TEXT_READY_STOCK_DESC_THREE,
  TEXT_READY_STOCK_DESC_TWO,
} from '../constants';
import { Item } from './item';
import styles from './styles.module.scss';
import type { Component } from './types';

export const DesktopModalContent: Component = ({
  modelThumbnail,
  fullName,
  piDealerListData,
  submodelList,
}) => (
  <>
    <div className={styles.containerPiInfo}>
      <Image
        alt="model image"
        height={144}
        src={`${joinSgcmMedia(modelThumbnail)}`}
        width={216} />
      <div className={styles.containerAsideContent}>
        <div className={styles.textModalTitle}>
          Dealer with
          {' '}
          <span className={styles.isRedText}>
            {fullName}
          </span>
          {' '}
          that are ready stocks
        </div>
        <div className={styles.textReadyStockDesc}>
          <Check
            aria-label="check"
            className={styles.iconCheck}
            size={ICON_SIZE_IN_PIXEL} />
          <span>
            {TEXT_READY_STOCK_DESC_ONE}
          </span>
        </div>
        <div className={styles.textReadyStockDesc}>
          <Check
            aria-label="check"
            className={styles.iconCheck}
            size={ICON_SIZE_IN_PIXEL} />
          <span>
            {TEXT_READY_STOCK_DESC_TWO}
          </span>
        </div>
        <div className={styles.textReadyStockDesc}>
          <Check
            aria-label="check"
            className={styles.iconCheck}
            size={ICON_SIZE_IN_PIXEL} />
          <span>
            {TEXT_READY_STOCK_DESC_THREE}
          </span>
        </div>
      </div>
    </div>
    <div className={styles.containerReadyStocks}>
      <Image
        alt="icon exclamation mark"
        className={styles.iconExclamationMark}
        height={ICON_SIZE_IN_PIXEL}
        src="https://i.i-sgcm.com/new_cars/green_tick_33x33.png"
        width={ICON_SIZE_IN_PIXEL} />
      <div>
        {TEXT_READY_STOCK_DESC_FOUR}
        <TextLink
          className={styles.textViewMoreDealers}
          href={`${joinSgcmSite('/articles/advice/understanding-what-vac-ready-stock-is-30682')}`}
          target="_blank"
          text="VITAS Approval Code (VAC)" />
        {TEXT_READY_STOCK_DESC_FIVE}
      </div>
    </div>
    <div className={styles.containerSubmodels}>
      <div className={cx(
        styles.containerTableHeader,
        styles.containerTableRow,
      )}>
        <div className={styles.containerTableCell}>
          {COLUMN_TITLE_DEALER}
        </div>
        <div className={styles.containerTableCell}>
          {COLUMN_TITLE_SUBMODEL}
        </div>
        <div className={styles.containerTableCell}>
          {COLUMN_TITLE_PRICE}
        </div>
      </div>
      {piDealerListData?.map(parallelDealer => (
        <Item
          key={`item-${parallelDealer.id}`}
          parallelDealer={parallelDealer}
          submodelList={submodelList} />
      ))}
    </div>
  </>
);
